/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class MonitorEditConversationsReviewIssueNewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit.conversations.review.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(MonitorEditConversationsReviewIssueNewRoute);
